import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import NGLContext from "../NGLContext";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {getPropValue} from '../NGLViewer'
import RepresentationTab from './RepresentationTab'
import SelectionTab from './SelectionTab'
import LegendTab from './LegendTab'


const styles = theme => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
        position: 'relative',
    },
    menuButton: {
        marginInline: '1em',
        outline: 'none !important',
        margin: '0.25em',
    },
});

@withStyles(styles)
class CenteredTabs extends Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
    };

    state = {
        value: 0,
    };

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (event, value) => {
        this.setState({value});
    };

    render() {
        const {classes} = this.props;

        return (
            <NGLContext.Consumer>
                {(contextNGL) => (
                    <React.Fragment>
                        <div className={classes.root}>
                            <Tabs
                                value={this.state.value}
                                onChange={this.handleChange}
                                indicatorColor="primary"
                                textColor="primary"
                                centered
                            >
                                <Tab label="Representation"
                                     className={classes.menuButton}/>
                                <Tab label="Selection"
                                     className={classes.menuButton}/>
                                <Tab label="Legend"
                                     className={classes.menuButton}/>
                            </Tabs>
                            {this.state.value === 0 && contextNGL.stage &&
                            <RepresentationTab
                                representation={getPropValue(contextNGL, ['stage', 'compList', contextNGL.componentIndex, 'reprList', contextNGL.representationIndex[contextNGL.componentIndex]])}/>
                            }
                            {this.state.value === 1 && contextNGL.stage &&
                            <SelectionTab/>
                            }
			    {this.state.value === 2 && contextNGL.stage &&
			    <LegendTab/>
			    }
                        </div>
                    </React.Fragment>
                )}
            </NGLContext.Consumer>

        );
    }
}

export default CenteredTabs;